<template>
    <div>

        <div
            v-if="!hasSubmitted"
            class="flex justify-center items-center p-5 border-grey-light bg-grey-lightest"
        >
            <div class="w-full h-full">

                <div class="font-semibold mb-3">
                    Submit a Review
                </div>

                <ProductReviewsCreateReviewScoreInput
                    v-model="score"
                    class="mb-4"
                />

                <TextAreaInput
                    v-model="$v.comment.$model"
                    :invalid="$v.comment.$error"
                    class="w-full mb-5"
                >
                    <template #errors>
                        <div v-if="!$v.comment.maxLength && $v.comment.$dirty">
                            Please keep your comment less than 1,000 characters in length.
                        </div>
                    </template>
                </TextAreaInput>

                <Button
                    :loading="isSubmitLoading"
                    :disabled="$v.comment.$error"
                    class="small-btn"
                    text="Submit"
                    @click="submit"
                />

            </div>
        </div>

        <div
            v-else
            class="flex justify-center items-center text-center p-5 border-grey-light bg-green-light font-semibold text-white"
        >
            Thank you for submitting a review.<br>
            Once approved, it will be visible here for others to see.
        </div>

    </div>
</template>

<script>
import { maxLength } from 'vuelidate/lib/validators';
import ProductReviewsCreateReviewScoreInput from '~/components/ProductReviewsCreateReviewScoreInput';
import TextAreaInput from '~/components/TextArea';
import Button from '~/components/Button';

export default {

    components: {
        ProductReviewsCreateReviewScoreInput,
        TextAreaInput,
        Button,
    },

    props: {
        productId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            score: 5,
            comment: '',
            hasSubmitted: false,
            isSubmitLoading: false,
        };
    },

    methods: {
        async submit() {
            this.isSubmitLoading = true;
            try {
                await this.$axios.post(`/products/${this.productId}/reviews`, {
                    score: this.score,
                    comment: this.comment,
                });
            } catch (error) {
                // TODO
            }
            this.isSubmitLoading = false;
            this.hasSubmitted = true;
        },
    },

    validations: {
        comment: {
            maxLength: maxLength(1000),
        },
    },

};
</script>

<style lang="scss" scoped>
.small-btn {
    transform-origin: top left;
    transform: scale(0.9);
}
</style>
